import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import {
  getPlaceholder,
  getRoomType,
  roomType,
} from '../../../../data/models/funnelOrder/roomType'
import { AppState } from '../../../../data/state'

import { BlockItem, BlockSelect, BlockSelectType } from 'components/BlockSelect'
import { Button, TYPE } from 'components/Button'
import Icon from 'components/Icon'
import { List, ListItem } from 'components/List'
import { Modal, ModalFooter, ModalHeader } from 'components/Modal'

import Content from '../../../shared/content'

import { ROOMTYPE } from 'Icon/roomType'
import { SRPRS } from 'Icon/srprs'
import {
  ActionModalInnerComponentProps,
  withActionListModal,
} from '../../../../elements/modals/ActionListModal'

import HostelTrigger from '../../../../elements/triggers/info/hostelTrigger'

import { Theme } from '../../../../data/models/funnelOrder/theme'
import { optionSelection } from '../../../../tracking/actions/optionSelection'

import TextTooltip from '../../../../elements/tooltips/textTooltip'

interface RoomTypeProps {
  hideTrigger?: boolean
  tripType: any
}

interface RoomTypeState {
  value: roomType
}

class RoomTypeModal extends React.Component<
  ActionModalInnerComponentProps & RoomTypeProps,
  RoomTypeState
> {
  constructor(props: ActionModalInnerComponentProps & RoomTypeProps) {
    super(props)
    this.state = {
      value: props.value,
    }
    this.handleSave = this.handleSave.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  public handleSave() {
    if (this.props.onSave !== undefined) {
      this.props.onSave(this.state.value)
    }
  }

  public handleClose() {
    if (this.props.onClose !== undefined) {
      this.props.onClose()
    }
  }

  public handleChange(value: string) {
    this.setState({
      value: +value,
    })
  }

  public render() {
    const isDrive =
      this.props.tripType === Theme.drive ||
      this.props.tripType === Theme.multiDrive
    const isFoodLoversDrive = this.props.tripType === Theme.foodLoversDrive

    return (
      <Modal
        size="xl"
        animationType={'1'}
        sticky={true}
        onDismiss={this.handleSave}
        disableOutsideClick={this.props.disableOutsideClick}
      >
        <ModalHeader
          icon={SRPRS.bedColored}
          iconProps={{ viewBox: '0 0 46 38' }}
        >
          <Content contentKey="accomodation">Accomodation</Content>
        </ModalHeader>
        <div className="content">
          <List horizontal={true} borderType={'horizontal-mobile'}>
            <ListItem>
              <Content contentKey="always-neat">
                Invariably tidy and clean
              </Content>
            </ListItem>
            <ListItem>
              <Content contentKey="pleasant-location">Central location</Content>
            </ListItem>
            <ListItem>
              <Content contentKey="rated-8-or-higher">
                Rated an 8 or higher
              </Content>
            </ListItem>
          </List>
          {this.state.value === roomType.budget && !isDrive ? (
            <HostelTrigger roomType={this.state.value} />
          ) : null}
          <BlockSelect
            model="roomType"
            value={this.state.value}
            onChange={this.handleChange}
            type={BlockSelectType.acco}
            nrCols={[4]}
            slider
          >
            {!isFoodLoversDrive && (
              <BlockItem
                value={roomType.budget}
                label={
                  !isDrive ? (
                    <Content contentKey="roomType-budget">Shared</Content>
                  ) : (
                    <Content contentKey="roomType-budget-drive">
                      Glamping
                    </Content>
                  )
                }
                labelSubline={<Content contentKey="hostel">Hostel</Content>}
                illustration={
                  !isDrive ? (
                    <Icon viewBox="0 0 512 344" icon={ROOMTYPE.shared} />
                  ) : (
                    <Content contentKey="roomType-budget-description">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Donec
                    </Content>
                  )
                }
                footerButton={
                  !isDrive ? (
                    <TextTooltip
                      contentKey="roomType-budget-info-content"
                      placeholder="Shared accomodation info"
                    >
                      <Button type={TYPE.info} negative={true} />
                    </TextTooltip>
                  ) : (
                    undefined
                  )
                }
                footerText=""
              />
            )}
            <BlockItem
              value={roomType.basic}
              label={<Content contentKey="roomType-basic">Basic</Content>}
              labelSubline={
                <Content contentKey="subtitle-basic-drive">Basic</Content>
              }
              illustration={
                !isDrive ? (
                  <Icon viewBox="0 0 512 344" icon={ROOMTYPE.basic} />
                ) : (
                  <Content contentKey="roomType-basic-description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Donec
                  </Content>
                )
              }
              footerButton={
                !isDrive ? (
                  <TextTooltip
                    contentKey="roomType-basic-info-content"
                    placeholder="Basic accomodation info"
                  >
                    <Button type={TYPE.info} negative={true} />
                  </TextTooltip>
                ) : (
                  undefined
                )
              }
              footerText=""
            />
            <BlockItem
              value={roomType.comfort}
              label={
                !isDrive ? (
                  <Content contentKey="roomType-comfort">Comfort</Content>
                ) : (
                  <Content contentKey="roomType-comfort-drive">Plus</Content>
                )
              }
              labelSubline={
                <Content contentKey="hotel-bnb">Hotel &amp; apartment</Content>
              }
              illustration={
                !isDrive ? (
                  <Icon viewBox="0 0 512 344" icon={ROOMTYPE.comfort} />
                ) : (
                  <Content contentKey="roomType-comfort-descripition">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Donec
                  </Content>
                )
              }
              footerButton={
                !isDrive ? (
                  <TextTooltip
                    contentKey="roomType-comfort-info-content"
                    placeholder="Comfort accomodation info"
                  >
                    <Button type={TYPE.info} negative={true} />
                  </TextTooltip>
                ) : (
                  undefined
                )
              }
              footerRating={
                !isDrive ? (
                  <Content contentKey="starRating-comfort">3-4 sterren</Content>
                ) : (
                  undefined
                )
              }
            />
            {!isFoodLoversDrive && (
              <BlockItem
                value={roomType.premium}
                label={
                  !isDrive ? (
                    <Content contentKey="roomType-premium">Premium</Content>
                  ) : (
                    <Content contentKey="roomType-premium-drive">
                      Special
                    </Content>
                  )
                }
                labelSubline={
                  <Content contentKey="subtitle-premium-description">
                    Premium
                  </Content>
                }
                illustration={
                  !isDrive ? (
                    <Icon viewBox="0 0 512 344" icon={ROOMTYPE.premium} />
                  ) : (
                    <Content contentKey="roomType-premium-description">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Donec
                    </Content>
                  )
                }
                footerButton={
                  !isDrive ? (
                    <TextTooltip
                      contentKey="roomType-premium-info-content"
                      placeholder="Premium accomodation info"
                    >
                      <Button type={TYPE.info} negative={true} />
                    </TextTooltip>
                  ) : (
                    undefined
                  )
                }
                footerRating={
                  !isDrive ? (
                    <Content contentKey="starRating-premium">5 sterren</Content>
                  ) : (
                    undefined
                  )
                }
              />
            )}
          </BlockSelect>
        </div>
        <ModalFooter onClose={this.handleClose} onSave={this.handleSave} />
      </Modal>
    )
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    value: state.funnelOrder.roomType,
    tripType: state.funnelOrder.theme,
  }
}

const Accomodation = connect(
  (state: AppState) => ({
    value: state.funnelOrder.roomType,
    tripType: state.funnelOrder.theme,
  }),
  dispatch => ({
    onChange: (theRoomType: roomType) => {
      optionSelection('accomodation', getPlaceholder(theRoomType))
      dispatch(actions.change('funnelOrder.roomType', theRoomType))
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...ownProps,
    onChange: (theRoomType: roomType) => {
      if (stateProps.value !== theRoomType) {
        dispatchProps.onChange(theRoomType)
      }
    },
  }),
)(
  withActionListModal<RoomTypeProps>(RoomTypeModal, {
    icon: SRPRS.bedColored,
    iconProps: { viewBox: '0 0 46 38' },
    subject: (
      <Content addNode contentKey="accomodation">
        Accomodation
      </Content>
    ),
    getValue: getRoomType,
  }),
)

export default Accomodation
